import { useEffect, useState } from 'react'
import { Outlet, useLocation, Navigate } from 'react-router-dom'

import { useAuth0 } from '@auth0/auth0-react'
import { useTheme, LinearProgress } from '@mui/material'

import { isObjectEmpty } from '../util/util'
import { internalExternal, loginType } from '../util/gtm_utils'
import { useTriggerRequest } from '../hooks/useTriggerRequest'

function RequireQuestionnaire() {
  const { isAuthenticated, user } = useAuth0()
  const location = useLocation()
  const theme = useTheme()

  // Add a type for formData
  type FormDataType = {
    dataForm: {
      organizationName: string
      selectedOption: {
        name: string
        value: string
      }
    }
    isFormSubmitted: boolean
  }

  const [formData, setformData] = useState<FormDataType | null>(null)
  const [formDataLoading, setformDataLoading] = useState(true)

  const endpoint = user && isAuthenticated
    ? `https://${process.env.REACT_APP_AUTH0_CUSTOM_DOMAIN || process.env.REACT_APP_AUTH0_DOMAIN}/api/v2/users/${user.sub}`
    : ''

  const { refetch: refetchUserMeta } = useTriggerRequest({
    queryKey: ['userMeta', user?.sub ?? ''],
    endpoint,
    options: {
      enabled: false,
      onSuccess: (result) => {
        const user_metadata = typeof result?.user_metadata === 'undefined' ? {} : result.user_metadata
        if (!isObjectEmpty(user_metadata)) {
          setformData(result.user_metadata.formData)
          window.dataLayer.push({
            event: 'questionnaire_check',
            organizationName: result.user_metadata.formData.dataForm.organizationName,
            persona: result.user_metadata.formData.dataForm.selectedOption.value,
            loginType: user ? loginType(user) : '',
            internalExternal: internalExternal(result.user_metadata.formData.dataForm.organizationName)
          })
        } else {
          setformData({
            dataForm: {
              organizationName: '',
              selectedOption: {
                name: '',
                value: ''
              }
            },
            isFormSubmitted: false
          })
        }
        setformDataLoading(false)
      }
    }
  })

  useEffect(() => {
    if (isAuthenticated && user) {
      refetchUserMeta()
    }
  }, [isAuthenticated, user, refetchUserMeta])

  if (formDataLoading) {
    return (
      <div
        style={{
          height: '100vh',
          width: '100wh',
          backgroundColor: theme?.palette.secondary.main
        }}
      >
        <LinearProgress />
      </div>
    )
  }

  if (!formDataLoading && !formData?.isFormSubmitted) {
    return <Navigate to='/login-questionnaire' state={{ from: location }} />
  }

  return <Outlet />
}

export default RequireQuestionnaire
